<template>
    <v-container style="padding-top:80px" width="100%">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-layout row wrap :class="classDisabledview">
            <v-flex xs12 sm12 md12>
                <v-card flat class="text-xs-center ma-3" width="100%">

                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white; font-size:small"><v-icon size="14"
                                color="white">
                                mdi-information-variant </v-icon> VOLANTE DE ASISTENCIA JURIDICA</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-card-text class="font-weight-bold"> DATOS GENERALES</v-card-text>

                                <div style="padding-left:16px">

                                    <p style="font-size:15px"> <span style="font-size:15px" class="font-weight-bold">
                                            REPORTE: </span> <button @click="BuscarReporte()" type="button" class="mr-1"
                                            aria-haspopup="true" aria-expanded="false"><span class='reporteindice'>{{
                                                datos.nrreporte }} -
                                                {{ datos.svindice }}</span></button></p>

                                    <p style="font-size:15px"> <span style="font-size:15px" class="font-weight-bold">
                                            ASEGURADORA: </span>{{ this.datosAB.clnombre }}</p>

                                    <p style="font-size:15px"> <span style="font-size:15px" class="font-weight-bold">
                                            LOCALIDAD: </span>{{ this.datosAB.lonombre }}</p>

                                    <p v-if="this.datosAB.svestdanosveh < this.datosAB.svdeducible"
                                        style="font-size:15px">
                                        <span style="font-size:15px" class="font-weight-bold"> ASUNTO: </span>Asunto
                                        Extemporaneo
                                    </p>

                                    <p v-if="this.datosAB.diferenciaHoras > 24" style="font-size:15px"> <span
                                            style="font-size:15px" class="font-weight-bold"> ASUNTO: </span>Daños
                                        Menores al
                                        Deducible</p>
                                </div>

                            </v-col>

                            <v-col cols="12" md="6">
                                <v-card-text class="font-weight-bold">DATOS DEL ABOGADO</v-card-text>

                                <div style="padding-left:16px">
                                    <p style="font-size:15px"> <span style="font-size:15px" class="font-weight-bold">
                                            NOMBRE: </span>{{ this.datosAB.prnombre }}</p>


                                    <div v-for="(item, index) in datosContacto" :key="index">
                                        <p style="font-size:15px"> <span style="font-size:15px"
                                                class="font-weight-bold">
                                                {{ item.tcdesc.toUpperCase() }}: </span>{{ item.dcprdato.toUpperCase()
                                            }}
                                        </p>

                                    </div>


                                </div>



                            </v-col>
                        </v-row>


                    </v-card-text>
                </v-card>
            </v-flex>

            <Asegurado v-if="this.show == true" :validatermino="validatermino" :validaConclusion="validaConclusion"
                :svresponsabled="svresponsabled" :vista="'AB'" :datosGrals="datosAB" @reload="reload"></Asegurado>

            <Tercero v-if="this.show == true" :validatermino="validatermino" :vista="'AB'"
                :validaConclusion="validaConclusion" :svresponsabled="svresponsabled" @reload="reload"></Tercero>




        </v-layout>
    </v-container>
</template>


<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import Asegurado from "@/components/pages/Lideres/components/AseguradoLideres.vue";
import Tercero from "@/components/pages/Lideres/components/TerceroLideres.vue";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Lideres from "@/services/Lideres/Lideres.service.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Asegurado,
        Tercero,
    },
    data() {
        return {
            showcargando: true,
            show: false,
            validatermino: false,
            classDisabledview: '',
            validaConclusion: false,
            svresponsabled: false,
            displayInputs: {
                nrreporte: 0,
                svindice: 0
            },
            datos: {},
            datosAB: [],
            datosContacto: [],
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        reload(val) {
            this.$emit('ReloadEncabezado');
        },
        async BuscarReporte() {

            var datosRep = await MetodosGenerales.obtenerSessionReporte("reporte");

            let reporte = {
                nrreporte: datosRep.nrreporte,
                svindice: datosRep.svindice,
                aiclave: datosRep.aiclave,
                svfhconclusion: datosRep.svfhconclusion
            };

            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", datosRep.nrreporte);
            formData.append("svindice", datosRep.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });



            let routerName = MetodosGenerales.obtenerRouterName(datosRep.aiclave.toString());


            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                let url = this.$router.resolve({ name: `${routerName}` });

                window.open(url.href, '_blank');


            }
        },
        async obtenerDatosContacto() {
            this.datosContacto = await Lideres.ListardatoscontactoAB(this.datosAB.prclave);

        }

    },
    async mounted() {
        this.changeReporteMenuOption(this.$route.name);
        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice
        };
        //document.removeEventListener('visibilitychange', this.visibilitychange);

        await MetodosGenerales.verificarPermisoSolo('', "VerificarPermiso", "40").then((response) => {
            if (response.data.length > 0) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });


        var responseAJ = await Lideres.DatosPantallaAjustador(this.datos);

        this.datosAB = responseAJ[0];

        await this.obtenerDatosContacto();

        this.show = true;
        this.showcargando = false;
    }
}

</script>